import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Grid } from 'semantic-ui-react';
import DairyService from '~/api/services/dairy';
import { LocationEl } from './style';
import Drawer from '~/components/Drawer';
import { handleErrors } from '~/utils/helpers';

interface ShowLocationProps {
  locationId?: string;
  handleHiddenDrawer: () => void;
  isLoading?: boolean;
}

const ShowLocation: React.FC<ShowLocationProps> = (props) => {
  const { locationId, handleHiddenDrawer } = props
  const [isBusy, setIsBusy] = useState(false)
  const [showData, setShowData] = useState(null)
  const { t } = useTranslation()

  useEffect(() => {
    if (locationId) {
      fetchShowData()
    }
  }, [locationId])

  async function fetchShowData() {
    setIsBusy(true)
    try {
      const response = await DairyService.showDairyLocation(locationId)
      setShowData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderContent() {
    return <LocationEl.StyledGrid columns={1}>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Office name')}:</label>
          <div>{showData?.name}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Office type')}:</label>
          <div>{showData?.type}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Office email')}:</label>
          <div>{showData?.officeEmail}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Street name')}:</label>
          <div>{showData?.streetName}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Street number')}:</label>
          <div>{showData?.streetNumber}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('City')}:</label>
          <div>{showData?.city}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Zip Code')}:</label>
          <div>{showData?.zip}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Country')}:</label>
          <div>{showData?.countryLabel}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Phone number')}:</label>
          <div>{`${showData?.phonePrefixCountryPhoneCode || ''} ${showData?.phoneNumber || ''}`}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Phone number')}:</label>
          <div>{`${showData?.phonePrefixCountryPhoneCode || ''} ${showData?.telefaxNumber || ''}`}</div>
        </Grid.Column>
      </Grid.Row>
    </LocationEl.StyledGrid>
  }

  return <Drawer
    isBusy={isBusy}
    onHide={() => handleHiddenDrawer()}
    isVisible={Boolean(locationId)}
    header={t('Show location')}
    content={renderContent()}
    closeOnEscape
  />
}
export default ShowLocation